import { Checkbox } from "@chakra-ui/react";

const CommonCheckbox = ({ 
  isChecked, 
  onChange, 
  children, 
}) => {
  return (
    <Checkbox
      isChecked={isChecked}
      onChange={onChange}  
      sx={{
        '& .chakra-checkbox__control': {
          border: '1px solid #ccc',
          backgroundColor: 'white',

          // Evitem que desaparegui en hover o focus
          _hover: {
            backgroundColor: 'white',
            borderColor: '#999',
          },
          _focus: {
            boxShadow: 'none',
            borderColor: '#999',
          },
          _checked: {
            backgroundColor: 'blue.500',
            borderColor: 'blue.500',
            color: 'white',
          },
        },
      }}
    >
      {children}
    </Checkbox>   
  );
};

export default CommonCheckbox;
